import { Injectable } from '@angular/core';
import { BaseHttpService } from '../../../base/base-http.service';
import { notificationsFollowUpDto } from 'src/app/tabms/models/admin/notifications-follow-up';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class NotificationsFollowUpService extends BaseHttpService<notificationsFollowUpDto>{

  constructor(private httpClient: HttpClient) {
    super(httpClient)
   }

   getResourceUrl(): string {
     return 'TABNotificationsUsers';
   }
}
